'use client'

import React from 'react'
import { usePathname } from 'next/navigation'
import SimpleHeader from '@/components/Header/SimpleHeader'
import SimpleFooter from '@/components/Footer/SimpleFooter'
import styles from './styles.module.scss'

type SimpleHeaderUsed = 'additional_info' | 'group_join'

function getHeaderUsed(pathname: string): SimpleHeaderUsed | undefined {
  if (pathname === '/members/additional_info') {
    return 'additional_info'
  }
  if (pathname.startsWith('/members/group/join')) {
    return 'group_join'
  }
  return undefined
}

export default function SimpleLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname()
  const headerUsed = getHeaderUsed(pathname)

  return (
    <div className={styles.simpleLayout}>
      <SimpleHeader used={headerUsed} />
      <main className={styles.mainContent}>{children}</main>
      <SimpleFooter />
    </div>
  )
}
